import API from '../api'
import convertPagableData from '../convertPagableData'
import getUrl from './paths'

export const getOrganisationProbeDetails = (organisationId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getOrganisationProbeDetails, { organisationId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getAllProbeReports = (organisationId, page = 0, size = 10) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getAllProbeReports, { organisationId, page, size })
			.then((response) => {
				resolve(convertPagableData(response.data))
			})
			.catch((error) => {
				reject(error)
			})
	})

export const fetchFromProbe42 = (entityId) =>
	// entity id can be PAN, CIN or LLPIN
	new Promise((resolve, reject) => {
		API.get(getUrl.fetchFromProbe42, { entityId })
			.then((response) => {
				resolve(response)
			})
			.catch((error) => {
				reject(error)
			})
	})

// A probe report is fetched either by its own probeId (the report pages) or by the organisation
// (the older org-probe screens) — never both.
export const getchBriefDetailsProbe = (organisationId, probeId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProbeBriefDetails, probeId ? { probeId } : { organisationId })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getFinancialsProbe = (organisationId, probeId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProbeFinancials, probeId ? { probeId } : { organisationId })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getFinancialDetailsProbe = (organisationId, probeId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProbeFinancialDetails, probeId ? { probeId } : { organisationId })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getComplianceProbe = (organisationId, probeId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProbeCompliance, probeId ? { probeId } : { organisationId })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getChargesProbe = (organisationId, probeId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProbeCharges, probeId ? { probeId } : { organisationId })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((error) => {
				reject(error)
			})
	})

export const getShareholdingProbe = (organisationId, probeId) =>
	new Promise((resolve, reject) => {
		API.get(getUrl.getProbeShareholdings, probeId ? { probeId } : { organisationId })
			.then((response) => {
				resolve(response?.data)
			})
			.catch((error) => {
				reject(error)
			})
	})
